/*
 * Raccourci collant vers le widget de recherche de taille.
 *
 * Il se revele quand le bouton Rechercher du widget quitte l'ecran et y
 * ramene au clic.
 *
 * data-target : id de l'element <search-widget> a observer et a rejoindre.
 *
 * Element personnalise plutot que script au chargement : les sections sont
 * remplacees par innerHTML dans l'editeur de theme, un listener pose une seule
 * fois ne survivrait pas a une modification de reglage.
 */
if (!customElements.get('sticky-size-finder')) {
  customElements.define(
    'sticky-size-finder',
    class StickySizeFinder extends HTMLElement {
      connectedCallback() {
        this.widget = document.getElementById(this.dataset.target);
        this.button = this.querySelector('.sticky-size-finder__button');
        if (!this.widget || !this.button) return;

        // On observe le bouton du widget, pas le widget entier : sur un grand
        // ecran celui-ci peut rester partiellement visible alors que le bouton
        // est deja passe.
        const trigger = this.widget.querySelector('.search-widget__btn') || this.widget;
        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-visible', !entry.isIntersecting);
        });
        this.observer.observe(trigger);

        this.button.addEventListener('click', this.scrollToWidget.bind(this));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      scrollToWidget() {
        this.widget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  );
}
